import { render } from "./EditSurvivalWorkingTipsForm.vue?vue&type=template&id=790a07d9"
import script from "./EditSurvivalWorkingTipsForm.vue?vue&type=script&lang=js"
export * from "./EditSurvivalWorkingTipsForm.vue?vue&type=script&lang=js"

import "./EditSurvivalWorkingTipsForm.vue?vue&type=style&index=0&id=790a07d9&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "790a07d9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('790a07d9', script)) {
    api.reload('790a07d9', script)
  }
  
  module.hot.accept("./EditSurvivalWorkingTipsForm.vue?vue&type=template&id=790a07d9", () => {
    api.rerender('790a07d9', render)
  })

}

script.__file = "src/components/survival-working-tips/EditSurvivalWorkingTipsForm.vue"

export default script